@if (state.activePageVersion; as version) {
  <dojo-tiptap-editor-wrapper
    class="h-full"
    [valueControl]="contentCtrl"
    [outputFormat]="TiptapEditorOutputFormat.Html"
    [editable]="false"
    [scrollableParent]="state.scrollableContainer"
  />
} @else {
  @if (state.activePageVersion === null) {
    <div class="pt-4">
      <dojo-empty-state
        [isIconBig]="true"
        [image]="'assets/images/topic-practice/construction-barrier.svg'"
        [imageHeight]="121"
        [header]="'practice.notes_coming_soon' | transloco"
      />
    </div>
    <div class="mb-4 flex flex-col">
      <h3 class="text-primary mb-6 mt-8 text-lg font-semibold">{{ 'home_card.need_help' | transloco }}</h3>
      <dojo-card-link
        [routerLink]="`/${RootUrlParts.TopicPractice}`"
        [title]="'home_card.card_1.title' | transloco"
        [subtitle]="'home_card.card_1.subtitle' | transloco"
        [imageSrc]="
          state.darkMode ? 'assets/images/topic-practice/roundel-dark.svg' : 'assets/images/topic-practice/roundel.svg'
        "
        class="mb-5"
      ></dojo-card-link>

      <dojo-card-link
        [routerLink]="`/${RootUrlParts.TopicPractice}`"
        [title]="'home_card.card_2.title' | transloco"
        [subtitle]="'home_card.card_2.subtitle' | transloco"
        [imageSrc]="'assets/images/topic-practice/emblem.svg'"
      ></dojo-card-link>
    </div>
  }
}
